import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import Login from "./components/auth/Login/Login";
import PasswordPrompt from "./components/auth/PasswordPrompt/PasswordPrompt";
import Home from "./components/home/Home";
import VotingScreen from "./components/home/Voting";
import FinalVote from "./components/home/FinalVote";
import Goodbye from "./components/home/Goodbye";
import Resultados from "./components/home/Resultados";
import IntroduccionFinalVote from "./components/home/IntroduccionFinalVote";
import AdminAccess from "./components/admin/AdminAccess";
import AdminPanel from "./components/admin/AdminPanel";
import { auth } from "./firebase";
import { canManageAdminPanel } from "./utils/adminAccess";

const ProtectedRoute = ({ isAuthenticated, children }) =>
  isAuthenticated ? children : <Navigate to="/login" replace />;

const PublicRoute = ({ isAuthenticated, children }) =>
  isAuthenticated ? <Navigate to="/home" replace /> : children;

const AdminRoute = ({ isAuthenticated, children }) =>
  isAuthenticated && canManageAdminPanel() ? children : <Navigate to="/admin-access" replace />;

const AppRoutes = () => {
  const [authReady, setAuthReady] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(Boolean(user));
      setAuthReady(true);
    });

    return () => unsubscribe();
  }, []);

  if (!authReady) {
    return (
      <div className="app-loading-screen">
        <div className="app-loading-card">
          <p className="app-loading-kicker">Tofu Awards II</p>
          <h1>Preparando la gala</h1>
          <p>Verificando tu sesion y cargando la experiencia de votacion.</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to={isAuthenticated ? "/home" : "/login"} replace />} />
      <Route
        path="/login"
        element={
          <PublicRoute isAuthenticated={isAuthenticated}>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/password-prompt"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <PasswordPrompt />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-access"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            {canManageAdminPanel() ? <Navigate to="/admin" replace /> : <AdminAccess />}
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <AdminRoute isAuthenticated={isAuthenticated}>
            <AdminPanel />
          </AdminRoute>
        }
      />
      <Route
        path="/resultados"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Resultados />
          </ProtectedRoute>
        }
      />
      <Route
        path="/home"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/voting"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <VotingScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path="/special-awards"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <FinalVote />
          </ProtectedRoute>
        }
      />
      <Route
        path="/special-awards/intro"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <IntroduccionFinalVote />
          </ProtectedRoute>
        }
      />
      <Route
        path="/finalvote"
        element={
          <Navigate to="/special-awards" replace />
        }
      />
      <Route
        path="/goodbye"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Goodbye />
          </ProtectedRoute>
        }
      />
      <Route
        path="/introfinal"
        element={
          <Navigate to="/special-awards/intro" replace />
        }
      />
      <Route path="*" element={<Navigate to={isAuthenticated ? "/home" : "/login"} replace />} />
    </Routes>
  );
};

const App = () => (
  <Router>
    <AppRoutes />
  </Router>
);

export default App;
